window.addEventListener('DOMContentLoaded', () => {
    // Check the URL and delete the appropriate session storage
    const windowUrl = window.location.href;
    if (windowUrl.includes('look')) {
        sessionStorage.removeItem('customerCustomLooks'); // Delete 'customerCustomLooks' if URL contains 'look'
    } else if (windowUrl.includes('custom')) {
        sessionStorage.removeItem('customerLooks'); // Delete 'customerLooks' if URL contains 'custom'
    }

    pupulateSummaryWithProducts();
    populateFormWithProducts();
});

function pupulateSummaryWithProducts() {
	const summaryMenu = document.querySelector('.Summary');
	const looks = JSON.parse(sessionStorage.getItem('customerLooks')) || JSON.parse(sessionStorage.getItem('customerCustomLooks'));
	summaryMenu.innerHTML = '';

	looks.forEach((look, lookIndex) => {
		const lookDiv = document.createElement('div');
		lookDiv.className = 'look';
		lookDiv.innerHTML = `<h2>${lookIndex + 1}</h2>`;
		look.products.forEach(product => {
				lookDiv.innerHTML += `
					<div class="menu-product">
						<div class="look-drawer-content">
							<div class="look-drawer-image">
								<img src="${product.imageSrc}" alt="${product.title}">
							</div>
							<div class="look-drawer-info">
								<h3>${product.title}</h3>
							</div>
						</div>
					</div>
				`;
		});
		summaryMenu.appendChild(lookDiv);
	});
}

function populateFormWithProducts() {
    const inputForm = document.querySelector('#ContactForm');
    let builderType = '';
    let looks = [];

    // Check which session storage is present and set builderType
    if (sessionStorage.getItem('customerCustomLooks')) {
        looks = JSON.parse(sessionStorage.getItem('customerCustomLooks'));
        builderType = 'Custom look';
    } else if (sessionStorage.getItem('customerLooks')) {
        looks = JSON.parse(sessionStorage.getItem('customerLooks'));
        builderType = 'Bespoke look';
    }

    looks.forEach(look => {
        look.products.forEach(product => {
            const productInput = document.createElement('input');
            productInput.type = "hidden";
            productInput.name = `contact[${builderType} ${look.sessionNumber}]`;
            productInput.value = `Product: ${product.title}`;
            inputForm.insertAdjacentElement('beforeend', productInput);
        });
    });
}